<template>
  <div class="dlnkforums_component container">

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>

    <div class="row mb-3">
      <div class="col-4">
        <button type="button"
                v-on:click="$emit('goto_section_index')"
                class="btn btn-primary float-right ml-1">
          <i class="fas fa-chevron-left" aria-hidden="true"></i> &nbsp;Retour à l'index de la section
        </button>
      </div>

      <!-- SEARCH -->
      <!--      <div class="col-4">-->
      <!--        <input v-on:keyup="search_sections" type="text" placeholder="Rechercher ..."-->
      <!--               class="form-control-sm w-100 border" v-model="query">-->
      <!--      </div>-->
      <!-- END SEARCH -->

    </div>


    <div class="page-header">
      <h1>{{ topic.title }}</h1>
      <span class="dlnkforums-badge-category" style="background-color: #B22222;"></span>
      <span class="dlnkforums-category-name">{{ topic.section.name }}</span>
    </div>

    <div class="dlnkforums-topic-header">
      <div class="dlnkforums-topic-content pb-2">
        <div class="dlnkforums-post-avatar">
          <img alt="" width="45" :src="topic.author.photo_url"
               :title="topic.author.name" class="avatar avatar-circle">
        </div>
        <div class="dlnkforums-post-content">

          <span class="dlnkforums-topic-author">{{topic.author.name}}</span>
          <span class="dlnkforums-topic-date float-right">{{topic.created_at}}</span>

          <div class="dlnkforums-post-message">
            <span v-html="topic.message"></span>
          </div>

          <nav class="navbar navbar-expand-lg navbar-light mt-4" style="background-color: #e3f2fd;">

            <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse">
              <ul v-if="!topic.author.private" class="navbar-nav mr-auto">
                <li class="nav-item">
                  <a class="nav-link" href="javascript:;">{{topic.author.mobile_phone}}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#">{{topic.author.email}}</a>
                </li>
                <li class="nav-item">
                  <a :href="'/module/dlnkchat/chat?id=' + topic.author.id"
                     class="nav-link">
                    <i class="fa fa-comment" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <div class="dlnkforums-topic-content pb-2"
         v-for="post in posts"
         :key="post.id">

      <div class="dlnkforums-post-avatar">
        <img alt="" width="45" :src="post.author.photo_url"
             :title="post.author.name" class="avatar">
      </div>
      <div class="dlnkforums-post-content">
        <div class="dlnkforums-post-header">
          <span class="dlnkforums-post-author">{{ post.author.name }}</span>
          <span class="dlnkforums-post-date pull-right">{{ post.author.created_at }}</span>
        </div>
        <div class="dlnkforums-post-message trix-content">
          <span v-html="post.message"></span>
        </div>

        <nav class="navbar navbar-expand-lg navbar-light mt-4" style="background-color: #e3f2fd;">

          <button class="navbar-toggler" type="button" data-toggle="collapse"
                  data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                  aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul v-if="!post.author.private" class="navbar-nav mr-auto">

              <li class="nav-item">
                <a class="nav-link" href="#">{{post.author.mobile_phone}}</a>
              </li>

              <li class="nav-item">
                <a class="nav-link" href="#">{{post.author.email}}</a>
              </li>

<!--              <li class="nav-item">-->
<!--                <a href="javascript:;"-->
<!--                   class="nav-link">-->
<!--                  <i class="fa fa-comment" aria-hidden="true"></i>-->
<!--                </a>-->
<!--              </li>-->
            </ul>

            <ul class="navbar-nav ml-auto">
<!--              <li class="nav-item">-->
<!--                <a href="#" class="nav-link">-->
<!--                  <i class="fa fa-thumbs-up dlnkforums-navbar-icon" aria-hidden="true"></i>-->
<!--                  (<span id="vote_count_{$post->id}">{{post.vote_count}}</span> like)-->
<!--                </a>-->
<!--              </li>-->

              <li v-if="admin" class="nav-item">
                <a href="javascript:;" @click="delete_post(post.id)" class="nav-link">
                  <i class="fa fa-trash dlnkforums-navbar-icon" aria-hidden="true"></i>
                </a>
              </li>

            </ul>
          </div>
        </nav>

      </div>
    </div>
    <div id="topic-message" class="dlnkforums-topic-answer mt-3">
      <form id="post_form"
            method="post"
            @submit.prevent="post_post">
        <input type="hidden" name="post[group_id]"  :value="group_id">
        <input type="hidden" name="post[author_id]" :value="customer_id">
        <input type="hidden" name="post[topic_id]"  :value="topic.id">

        <ckeditor :editor="editor" v-model="post_message" :config="editor_config" name="post[message]"></ckeditor>

        <button type="submit" name="submitPost" class="btn btn-success mt-2">Envoyer</button>
      </form>
    </div>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: {
    customer_id: Number,
    group_id: Number,
    group_status: Number,
    admin: Number,
    topic: Object,
    base_url: String,
  },
  data: function () {
    return {
      timer: null,
      posts: [],
      query: '',
      message: false,
      message_type: '',
      post_message: '',
      method: '',
      name: '',
      description: '',
      editor: ClassicEditor,
      editor_config: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      },
      errors: {
        name: true,
        description: true
      }
    }
  },
  mounted() {
    this.get_posts()
    this.timer = setInterval(this.get_posts, 5000);
  },

  beforeDestroy () {
    clearInterval(this.timer);
  },

  computed: {

    submit_disabled: function () {
      return this.errors.name || this.errors.description;
    },
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    get_posts: async function () {
      const _this = this;
      let api_url = this.base_url + "posts.json";

      const secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      if (_this.group_id > 0) {
        api_url = api_url + "&group_id=" + _this.group_id;
      }

      api_url += '&topic_id=' + this.topic.id;

      axios.get(api_url)
          .then(function (response) {
            _this.posts = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    post_post: async function () {
      const _this = this;
      const api_url = this.base_url +  "posts";
      const secure_key = await get_token();

      const form_element = document.getElementById("post_form");
      const form_data = new FormData(form_element);
      form_data.append('post[message]', _this.post_message);
      form_data.append('secure_key', secure_key);
      form_data.append('customer_id', this.customer_id);

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
      })
          .then(function (response) {

            _this.message = "Post ajoutée";
            _this.message_type = 'alert-success';

            _this.post_message = "";

            _this.get_posts();
            $('#post_modal').modal('hide');
          })
          .catch(function (error) {
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

              _this.message = "";
              _this.message_type = 'alert-danger'
              for (var key in error.response.data) {
                _this.message += key + ' ' + error.response.data[key][0]
                _this.message += '<br>'
                /* use key/value for intended purpose */
              }

            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
    },

    delete_post: async function (post_id) {
      const _this = this;
      let url = this.base_url + "posts/" + post_id ;

      const secure_key = await get_token();
      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + this.customer_id;

      if (_this.group_id > 0) {
        url += "&group_id=" + _this.group_id;
      }

      axios.delete(url)
          .then(function (response) {
            _this.get_posts();
          })
          .catch(function (error) {
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

              _this.message = "";
              _this.message_type = 'alert-danger'
              for (var key in error.response.data) {
                _this.message += key + ' ' + error.response.data[key][0]
                _this.message += '<br>'
                /* use key/value for intended purpose */
              }

            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);

          })
          .then(function () {
                // always executed
              }
          );
    },

  }
}
</script>
